module.exports = __webpack_public_path__ + "static/img/006城市名片6.419dfed.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/006城市名片6.jpg
// module id = Lx3B
// module chunks = 0